import { organizationModule } from '@/store/organization/module'
import { assignmentModule } from '@/store/assignment/module'
import { isPromise } from '@/utils'
import type { Study } from '@pocketprep/types'

const getCurrentOrgDifficultyCounts = () => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentOrgDifficultyCounts = currentOrganization
        && assignmentModule.state.currentOrgDifficultyCounts[currentOrganization.objectId]?.value

    if (currentOrgDifficultyCounts && !isPromise(currentOrgDifficultyCounts)) {
        return currentOrgDifficultyCounts
    } else {
        return {}
    }
}

const getCurrentOrgAssignments = (): Record<string, Study.Class.PrebuiltQuizJSON> => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentOrgAssignments = currentOrganization
        && assignmentModule.state.currentOrgAssignments[currentOrganization.objectId]?.value

    if (currentOrgAssignments && !isPromise(currentOrgAssignments)) {
        return currentOrgAssignments
    } else {
        return {}
    }
}

export default {
    getCurrentOrgDifficultyCounts,
    getCurrentOrgAssignments,
}
